import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PageSelectDialogComponent } from '../PageSelectDialog/PageSelectDialogComponent'

@Injectable({
    providedIn: 'root'
})

export class AnalyticsDlgService {
    public static $name: string = 'analyticsDlgService';

    constructor(
                public dialog: MatDialog
    ) {
    }



    public open(data: any): any {

        const dialogRef = this.dialog.open(PageSelectDialogComponent, {
            height: "400px",
            data: data,
            disableClose: false
        });
        
        return dialogRef;

    }


}